import React from "react";
import { Outlet } from "react-router-dom";

const MessageModule = () => {
  return <Outlet />;
};

export default MessageModule;
